export default {
    about: 'A propos',
    legalMention: 'Mentions légales',
    blog: 'Blog',
    cgu: 'CGU',
    privacyPolicy: 'Politique de Confidentialité',
};
